import {
  partnerDefaultEnterpriseId,
  partnerDefaultOrganizationType,
} from "../../../../../config/referralsSettings"

export function GeneratePassword() {
  //Create a new password for this entity
  let pwd = Math.random().toString(36).substring(2, 14)
  //make sure that the password will be more than 6 chars
  if (pwd.length < 6) {
    pwd = pwd + Math.random().toString(36).substring(2, 14)
  }

  return pwd
}

export function getSOAROrganizationName(partnerName) {
  const organizationText = "(Referral Partner)"
  if (!!partnerName) {
    let newName = partnerName.replace(organizationText, "")
    return `${newName} ${organizationText}`
  } else {
    return partnerName
  }
}

export function getAddOrganizationVariables(
  userCtx,
  partnerName,
  partnerEmail,
  partnerCountry
) {
  //Create new SOAR organization (This auto creates the default admin user)
  const defaultOrgType = partnerDefaultOrganizationType()
  const defaultEnterpriseId = partnerDefaultEnterpriseId()

  const mutateVars = {
    staff_id: userCtx.session.user.staff_id,
    staff_name_first: partnerName,
    staff_name_last: "ReferralPartner",
    staff_email_address: partnerEmail,
    staff_account_password: "", //CreatePassword(),
    organization_name: getSOAROrganizationName(partnerName),
    organization_country: partnerCountry,
    organization_address: "",
    organization_city: "",
    organization_state: "",
    organization_zip_code: "",
    organization_website: "",
    organization_email_address: "",
    organization_phone_number: "",
    organization_type: defaultOrgType,
    enterprise_id: defaultEnterpriseId,
    admin_staff_enterprise_id: userCtx.session.user.enterprise_id,
    admin_staff_organization_id: userCtx.session.user.organization_id,
    admin_staff_enterprise_alias: userCtx.session.user.enterprise_alias,
    admin_staff_organization_alias: userCtx.session.user.organization_alias,
    staff_alias: userCtx.session.user.staff_alias,
  }

  return mutateVars
}
